import { createSlice } from "@reduxjs/toolkit";
import { getProfileById, getSingleAdAnalytics } from "./thunk";

export const initialState = {
    singleAd: null, // to store data from getAdById
    analyticsData: null, // to store data from getSingleAdAnalytics
    error: "", // for error message
    loading: false,
};

const adAnalyticsSlice = createSlice({
    name: "adAnalytics",
    initialState,
    reducers: {
        resetSingleAd: (state) => {
            state.singleAd = null; // reset singleAd to null
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProfileById.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProfileById.fulfilled, (state, action) => {
                const raw = action.payload?.data || action.payload || {};

                // Normalize siblings from API (supports both object array and Key/Value array formats)
                const rawSiblings = raw.family?.siblings || raw.siblings || [];
                let normalizedSiblings = rawSiblings;
                if (Array.isArray(rawSiblings) && rawSiblings.length > 0 && Array.isArray(rawSiblings[0])) {
                    normalizedSiblings = rawSiblings.map(kvList => (
                        kvList.reduce((acc, item) => {
                            if (item && typeof item === 'object' && 'Key' in item) {
                                acc[item.Key] = item.Value;
                            }
                            return acc;
                        }, {})
                    ));
                }
                if (!Array.isArray(normalizedSiblings)) normalizedSiblings = [];

                const isMale = (val) => {
                    if (typeof val === 'boolean') return val;
                    if (typeof val === 'number') return val === 1;
                    if (typeof val === 'string') {
                        const v = val.trim().toLowerCase();
                        return v === '1' || v === 'true' || v === 'male' || v === 'm';
                    }
                    return false;
                };

                const brothers = normalizedSiblings.filter(s => s && isMale(s.is_male)).length;
                const sisters = normalizedSiblings.filter(s => s && !isMale(s.is_male)).length;

                state.singleAd = {
                    ...raw,
                    family: {
                        ...(raw.family || {}),
                        siblings: normalizedSiblings,
                        brothers_count: typeof raw.family?.brothers_count === 'number' ? raw.family.brothers_count : brothers,
                        sisters_count: typeof raw.family?.sisters_count === 'number' ? raw.family.sisters_count : sisters
                    },
                    siblingCounts: { brothers, sisters }
                };
                state.loading = false;
            })
            .addCase(getProfileById.rejected, (state, action) => {
                state.error = action.payload?.error || null;
                state.loading = false;
            })
            .addCase(getSingleAdAnalytics.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSingleAdAnalytics.fulfilled, (state, action) => {
                state.analyticsData = action.payload;
                state.loading = false;
            })
            .addCase(getSingleAdAnalytics.rejected, (state, action) => {
                state.error = action?.payload?.error || null;
                state.loading = false;
            });
    },
});
export const { resetSingleAd } = adAnalyticsSlice.actions;
export default adAnalyticsSlice.reducer;
